import emitter from 'tiny-emitter/instance';

type EventHandler<T extends unknown[] = unknown[]> = (...args: T) => void;

export interface Emitter {
  $on<T extends unknown[]>(event: string, callback: EventHandler<T>): void;
  $once<T extends unknown[]>(event: string, callback: EventHandler<T>): void;
  $off<T extends unknown[]>(event: string, callback?: EventHandler<T>): void;
  $emit<T extends unknown[]>(event: string, ...args: T): void;
}

export default defineNuxtPlugin(() => {
  const emitterWrapper: Emitter = {
    $on: (event, callback) => emitter.on(event, callback),
    $once: (event, callback) => emitter.once(event, callback),
    $off: (event, callback) => emitter.off(event, callback),
    $emit: (event, ...args) => emitter.emit(event, ...args),
  };

  return {
    provide: {
      emitter: emitterWrapper,
    },
  };
});
